/* eslint-disable no-else-return */
/* eslint-disable prefer-template */
/* eslint-disable react/default-props-match-prop-types */
/* eslint-disable react/require-default-props */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-unused-vars */
import PropTypes from 'prop-types';
import * as React from 'react';
import { Col, Label, Input, Row } from 'reactstrap';
import { Button } from 'components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/pro-regular-svg-icons';
import ToolbarActions from './ToolbarActions';

import './TableToolbar.scss';
/* eslint-enable no-unused-vars */

class MTableToolbar extends React.Component {
  renderSearch() {
    const localization = {
      ...MTableToolbar.defaultProps.localization,
      ...this.props.localization,
    };

    if (this.props.search) {
      return (
        <Col md={6} lg={4}>
          <div className="form">
            <div className="form__form-group-field">
              <Label className="sr-only" htmlFor="tableSearch">
                Search
              </Label>
              <Input
                className="seatch-input"
                id="tableSearch"
                name="tableSearch"
                placeholder={localization.searchTooltip}
                type="search"
                value={this.props.searchText}
                onChange={event =>
                  this.props.onSearchChanged(event.target.value)
                }
              />
              <Button
                aria-label="Search"
                type="button"
                className="input-group-append"
                color="secondary"
                icon={<FontAwesomeIcon icon={faSearch} />}
              />
            </div>
          </div>
        </Col>
      );
    } else {
      return null;
    }
  }

  renderDefaultActions() {
    return (
      <div>
        <this.props.components.ToolbarActions
          actions={
            this.props.actions && this.props.actions.filter(a => a.isFreeAction)
          }
        />
      </div>
    );
  }

  renderSelectedActions() {
    return (
      <React.Fragment>
        <this.props.components.ToolbarActions
          actions={this.props.actions.filter(a => {
            if (typeof a === 'function') {
              const invoked = a();
              return invoked && invoked.isSelectedAction;
            } else return a.isSelectedAction || a.isFreeAction;
          })}
          data={this.props.selectedRows}
        />
      </React.Fragment>
    );
  }

  renderActions() {
    return (
      <div>
        {this.props.selectedRows && this.props.selectedRows.length > 0
          ? this.renderSelectedActions()
          : this.renderDefaultActions()}
      </div>
    );
  }

  renderSelectFilters() {
    const { filters, filterConfig, updateFilters } = this.props;
    const selectFilters = filterConfig.filter(conf => conf.type === 'select');
    return selectFilters.map(filter => (
      <Col xs="auto" className="labeled-toggle-container" key={filter.name}>
        <select
          className="form-control"
          name={`${filter.name}FilterSelect`}
          id={`${filter.name}FilterSelect`}
          onChange={e => updateFilters({ [filter.query]: e.target.value })}
          defaultValue={filters[filter.query] || filter.defaultValue}
        >
          {filter.displayName && (
            <option value="" disabled>
              {filter.displayName}
            </option>
          )}
          {filter.options.map(option => (
            <option value={option.value} key={option.name}>
              {option.name}
            </option>
          ))}
        </select>
      </Col>
    ));
  }

  renderCheckboxFilters() {
    const { filters, filterConfig, updateFilters } = this.props;
    const checkboxFilters = filterConfig.filter(
      conf => conf.type === 'checkbox'
    );
    return checkboxFilters.map(filter => (
      <Col xs="auto" key={filter.name}>
        <div className="custom-control custom-checkbox">
          <Input
            type="checkbox"
            className="custom-control-input"
            id={filter.name}
            name={filter.name}
            defaultChecked={filters[filter.query] || filter.defaultValue}
            onChange={e => {
              updateFilters({
                [filter.query]: e.target.checked,
              });
            }}
          />
          <Label htmlFor={filter.name} className="custom-control-label">
            Show active only
          </Label>
        </div>
      </Col>
    ));
  }

  render() {
    const localization = {
      ...MTableToolbar.defaultProps.localization,
      ...this.props.localization,
    };

    const { state, totalCount, clearSelection } = this.props;

    const pageSize = +(state.pageSize || 5);
    const start = pageSize * +(state.page || 0);
    let end = start + pageSize;
    if (end > totalCount) {
      end = totalCount;
    }

    const selectedRowsCount =
      this.props.selectedRows && this.props.selectedRows.length > 0
        ? localization.nRowsSelected.replace(
            '{0}',
            this.props.selectedRows.length
          )
        : this.props.title;

    const pagingSummary =
      totalCount > 0
        ? localization.pagingSummary
            .replace('{0}', start + 1)
            .replace('{1}', end)
            .replace('{2}', totalCount)
        : '';

    return (
      <Row className="table-toolbar align-items-center">
        {this.renderSearch()}
        {pagingSummary && (
          <Col xs="auto">
            <h5>{pagingSummary}</h5>
          </Col>
        )}
        <Col xs={12} className="col-lg">
          <Row className="align-items-center justify-content-end">
            {selectedRowsCount && (
              <>
                <Col xs="auto">
                  <h5>{selectedRowsCount}</h5>
                </Col>
                |
                <Col xs="auto">
                  <button
                    type="button"
                    style={{
                      background: 'none',
                      border: 'none',
                      padding: 0,
                      textDecoration: 'underline',
                    }}
                    onClick={clearSelection}
                  >
                    Unselect all
                  </button>
                </Col>
              </>
            )}
            <Col xs="auto">{this.renderActions()}</Col>
            {this.renderSelectFilters()}
            {this.renderCheckboxFilters()}
          </Row>
        </Col>
      </Row>
    );
  }
}

MTableToolbar.defaultProps = {
  actions: [],
  columns: [],
  columnsButton: false,
  onSearchChanged: () => {},
  clearSelection: () => {},
  onColumnsChanged: () => {},
  localization: {
    addRemoveColumns: 'Add or remove columns',
    nRowsSelected: '{0} row(s) selected',
    showColumnsTitle: 'Show Columns',
    showColumnsAriaLabel: 'Show Columns',
    exportTitle: 'Export',
    exportAriaLabel: 'Export',
    exportName: 'Export as CSV',
    searchTooltip: 'Search',
    pagingSummary: 'Showing {0} to {1} of {2}.',
  },
  search: true,
  searchText: '',
  selectedRows: [],
  title: '',
  components: {
    ToolbarActions,
  },
  filterConfig: [],
};

MTableToolbar.propTypes = {
  actions: PropTypes.array,
  localization: PropTypes.object.isRequired,
  onSearchChanged: PropTypes.func.isRequired,
  search: PropTypes.bool.isRequired,
  searchText: PropTypes.string.isRequired,
  selectedRows: PropTypes.array,
  title: PropTypes.string.isRequired,
  state: PropTypes.shape({}).isRequired,
  filters: PropTypes.shape({}),
  filterConfig: PropTypes.arrayOf(PropTypes.shape({})),
  updateFilters: PropTypes.func.isRequired,
  totalCount: PropTypes.number.isRequired,
  clearSelection: PropTypes.func.isRequired,
};

export default MTableToolbar;
/* eslint-enable react/default-props-match-prop-types */
/* eslint-enable react/require-default-props */
/* eslint-enable react/forbid-prop-types */
/* eslint-enable react/no-array-index-key */
/* eslint-enable react/destructuring-assignment */
/* eslint-enable prefer-template */
/* eslint-enable no-else-return */
